import { Pipe, PipeTransform, inject } from '@angular/core';
import { StatusFilaIntegracao } from '../../enum/StatusFilaIntegracao';
import { LabelService } from '../../services/label/label.service';

@Pipe({
  name: 'statusFilaIntegracao',
})
export class StatusFilaIntegracaoPipe implements PipeTransform {
  private labelService = inject(LabelService);

  transform(status: StatusFilaIntegracao): string {
    const statuses = {
      0: 'Na Fila',
      1: 'Em Execucao',
      2: 'Falha Na Comunicacao',
      3: this.labelService.get('statusIntegradoCriticaNoProvedor'),
      4: this.labelService.get('statusIntegradoAguardandoRespostaProvedor'),
      5: 'Integrado Movimentacao Aceita',
      6: 'Integrado Movimentacao Recusada',
      7: 'Envio Programado',
      9: 'Envio Cancelado',
    };

    return statuses[status];
  }
}
